/*
 * Per-product cart quantity limit.
 * ---------------------------------
 * Caps specific products/variants to a maximum quantity per cart, no matter how
 * they get added to the cart:
 *   - Replo "Add to Cart and go to checkout" button (fetch /cart/add.js -> /checkout)
 *   - The /discount/CODE?redirect=/cart/add?id=...&quantity=1 permalink buttons
 *   - The theme's own AJAX add-to-cart (jQuery)
 *   - The cart-page quantity selector
 *
 * It works by re-clamping the cart after ANY cart mutation: it reads the cart,
 * and if a capped line is over its max, it sets that line back down to the max.
 * For fetch-based adds it finishes clamping BEFORE the original request resolves,
 * so a button that redirects to /checkout right after the add still lands with
 * the corrected quantity. CTA buttons are never blocked or modified.
 *
 * Currently enforced:
 *   No Cost Boss Workshop  ->  max 1 per cart
 *     variants 50258615566646 and 54019704750390  /  product 3430497
 *
 * To cap another product later: add its variant id to VARIANT_CAPS (preferred)
 * or its product id to PRODUCT_CAPS. The value is the max quantity per cart.
 */
(function () {
  var VARIANT_CAPS = {
    50258615566646: 1, // No Cost Boss Workshop
    54019704750390: 1  // No Cost Boss Workshop (checkout-permalink variant)
  };
  var PRODUCT_CAPS = { 3430497: 1 }; // No Cost Boss Workshop (covers all its variants)

  var hasOwn = Object.prototype.hasOwnProperty;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Capture the ORIGINAL fetch before we patch window.fetch, so our own cart
  // reads/writes never get intercepted (no recursion).
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var clamping = false;

  function capFor(item) {
    if (hasOwn.call(VARIANT_CAPS, item.variant_id)) return VARIANT_CAPS[item.variant_id];
    if (hasOwn.call(VARIANT_CAPS, item.id)) return VARIANT_CAPS[item.id];
    if (hasOwn.call(PRODUCT_CAPS, item.product_id)) return PRODUCT_CAPS[item.product_id];
    return null;
  }

  function getCart() {
    return nativeFetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  // Read the cart and push any over-cap line back down to its max.
  // Resolves to true if it changed anything, false otherwise.
  function clampCart() {
    if (clamping || !nativeFetch) return Promise.resolve(false);
    clamping = true;
    return getCart().then(function (cart) {
      var updates = {};
      var changed = false;
      (cart.items || []).forEach(function (item) {
        var max = capFor(item);
        if (max != null && item.quantity > max) {
          updates[item.key] = max;
          changed = true;
        }
      });
      if (!changed) return false;
      return nativeFetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); }).then(function (newCart) {
        refreshThemeCartUI(newCart);
        return true;
      });
    }).catch(function () {
      return false;
    }).then(function (result) {
      clamping = false;
      return result;
    });
  }

  // Re-render the theme's cart UI after a correction, using the theme's own
  // helpers when they exist. Wrapped in try/catch so it can never break a CTA.
  function refreshThemeCartUI(cart) {
    try {
      if (document.querySelector('[data-cart-wrapper]') && typeof window.cartPageUpdate === 'function') {
        window.cartPageUpdate(cart);
      } else if (typeof window.buildCart === 'function') {
        window.buildCart(cart, false);
      }
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = (cart.item_count > 0 && cart.item_count < 100) ? cart.item_count : '';
      }
    } catch (e) {}
  }

  function isCartMutation(url) {
    if (!url) return false;
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(url));
  }

  // --- Patch fetch (Replo + any modern add-to-cart). Clamp BEFORE the original
  //     promise resolves so a follow-up redirect to /checkout waits for it. ---
  if (window.fetch) {
    var passthroughFetch = window.fetch;
    // Call the original with `window` as the receiver and never throw. This
    // wrapper fronts every fetch on the page (this file loads before the Shopify
    // app scripts), and Safari enforces the Window receiver on fetch — passing
    // `this` (undefined under strict mode) threw a TypeError there and stopped
    // Rebuy's bundle from loading at all. Chrome tolerated it, hence Safari-only.
    window.fetch = function (input, init) {
      var url;
      try {
        url = (typeof input === 'string') ? input : (input && input.url);
      } catch (e) {
        return passthroughFetch.apply(window, arguments);
      }
      var promise = passthroughFetch.apply(window, arguments);
      try {
        if (!clamping && isCartMutation(url)) {
          return promise.then(function (resp) {
            return clampCart().then(function () { return resp; });
          });
        }
      } catch (e) { /* fall through to the untouched promise */ }
      return promise;
    };
  }

  // --- Patch XHR (the theme's jQuery add + cart-page quantity changes). Clamp
  //     after the request finishes, then refresh the cart UI. ---
  var XHR = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (XHR && XHR.open && XHR.send) {
    var origOpen = XHR.open;
    var origSend = XHR.send;
    XHR.open = function (method, url) {
      this.__isCartMutation = isCartMutation(url);
      return origOpen.apply(this, arguments);
    };
    XHR.send = function () {
      if (this.__isCartMutation && !clamping) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            // Let the theme's own success handler run first, then correct.
            setTimeout(clampCart, 0);
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // --- Safety net: clamp on initial load (covers the /cart/add permalink, which
  //     navigates to /cart) and on bfcache restore. ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { clampCart(); });
  } else {
    clampCart();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) clampCart(); });
})();
